import React from 'react'
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from './CommonUtils/SweetAlerts';
import { config } from './CommonUtils/CommonURLS';
import { CommonAxiosPost } from './CommonUtils/CommonAxios';
export default function ChangePassword({ closeModal }) {

    console.log("dsdsdsd", closeModal);
    const handleLogout = () => {

        // ✅ Clear session storage
        sessionStorage.clear();



        // ✅ Clear all cookies (current domain)
        document.cookie.split(";").forEach(cookie => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });

        // ✅ Clear browser cache (if supported)
        if ("caches" in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }

        // ✅ Prevent back navigation
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => {
            window.history.go(1);
        };

        // ✅ Redirect to login page
        window.location.replace("/");   // better than navigate()
    };
    ;

    const changepswFormik = useFormik({
        enableReinitialize: true,
        initialValues: {

            oldpassword: "",
            newpassword: "",
            renewpassword: "",
        },
        validationSchema: Yup.object({
            oldpassword: Yup.string()
                .required('Old password is required')
                .min(8, 'Password must be at least 8 characters'),
            newpassword: Yup.string()
                .required('New password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(/[0-9]/, 'Password must contain at least one numeric character')
                .matches(/[a-zA-Z]/, 'Password must contain at least one alphabetic character')
                .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'Password must contain at least one lowercase letter'),
            renewpassword: Yup.string()
                .required('Confirm new password is required')
                .oneOf([Yup.ref('newpassword')], 'Retype Password must match with  New Password')
        }),
        onSubmit: (val) => {

            console.log("Change Password Form Values:", val);
            Swal.fire({
                text: "Are you sure you want to Change Password?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Change it!",
                cancelButtonText: "No, cancel!",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = config.url.FAC_URL + "changePassword";
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlert2(res?.data?.sdesc)
                            handleLogout();

                        } else {
                            failureAlert(res?.data?.sdesc || "Failed to Change Password");
                        }
                    })
                }
            });
        },
    })


    return (
        <>

            {/* <div className="faculty-card"> */}
            <div className='fac-topbar'>

                <div className='fac-detnew'>
                    <h5 className='mb-0'>Change Password</h5>
                </div>

            </div>
            <FormikProvider value={changepswFormik}>

                <Form onChange={changepswFormik?.handleChange} onSubmit={changepswFormik?.handleSubmit} className="form_adjust faculty-form" >

                    <bie.Row className="px-2 pt-3 mb-3">
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory' >Old Password</label>
                            <Field type="text" name="oldpassword" className="form-control" />
                            <ErrorMessage name="oldpassword" component="div" className="text-danger" />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory'>New Password</label>
                            <Field type='text' name="newpassword" className='form-control' />
                            <ErrorMessage name="newpassword" component="div" className="text-danger" />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory'>Re-enter New Password</label>
                            <Field type='text' name="renewpassword" className='form-control' />
                            <ErrorMessage name="renewpassword" component="div" className="text-danger" />
                        </bie.Col>
                    </bie.Row>
                    <bie.Alert variant='success'>
                        <div>
                            <ul>
                                <li>Password must be at least 8 characters.</li>
                                <li>Must have at least one numeric, one alphabet, and one special character.</li>
                                <li>Must have at least one uppercase and one lowercase character.</li>
                            </ul>
                        </div>
                    </bie.Alert>

                    <div className="d-flex justify-content-end mt-3">

                        <button
                            type="submit"
                            className="btn btn-primary btn-sm submit-btn border-0 modal-footbtn"
                        >
                            Reset Password
                        </button>
                        {closeModal && (
                            <button
                                type="button"
                                className="btn btn-danger btn-sm border-0 modal-footbtn ms-2"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                        )}

                    </div>

                </Form>

            </FormikProvider >



        </>
    )
}
